import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const menuRouter: Array<RouteRecordRaw> = [
    {
        path: '/menu',
        name: '菜单管理',
        component: Layout,
        redirect: '/menu/list',
        meta: { title: '菜单管理', icon: 'icon-menu', alwaysShow: true },
        children: [
            {
                path: 'list',
                name: '菜单列表',
                component: () => import('@/views/menu/List.vue'),
                meta: { title: '菜单列表' ,keepAlive: true, depth: 30}
            },
        ]
    }
]

export default menuRouter